import Row from "./row";

export default class Block {
	constructor(rows = {}) {
		this.rows = Object.entries(rows).reduce((acc, [key, row]) => {
			acc[key] = new Row(row);
			return acc;
		}, {});
	}
	getRows() {
		return this.rows;
	}
}
